import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {LayoutService} from 'src/app/layout/service/app.layout.service';
import {AppSidebarComponent} from './app.sidebar.component';
import {UserService} from "../shared/services/user.service";
import {CookieService} from "ngx-cookie-service";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import {environment} from "../../environments/environment";
import {TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',

})
export class AppTopbarComponent implements OnInit {
    @ViewChild('menubutton') menuButton!: ElementRef;
    token: any;
    id: string = "";
    dropdownVisible = false;
    selectedLanguage: string = '';
    languageOptions = [
        {label: 'English', value: 'en'},
        {label: 'Deutsch', value: 'de'},
        {label: 'Türkçe', value: 'tr'}
    ];

    ref: DynamicDialogRef | undefined;

    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

    constructor(
        public layoutService: LayoutService,
        public dialogService: DialogService,
        private translateService: TranslateService,
        public el: ElementRef,
        private cookieService: CookieService,
        private userService: UserService,
        public translate: TranslateService) {
    }

    ngOnInit() {
        this.token = this.cookieService.get('access_token');

        this.userService.getLoggedInUser().subscribe({
            next: (data) => {
                console.log('Logged-in user data:', data);
                this.id = data.id;

            },
            error: (error: HttpErrorResponse) => {
                console.error('Error occurred while fetching user data:', {
                    status: error.status,
                    statusText: error.statusText,
                    message: error.message,
                    url: error.url
                });
            },
        });

    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onProfileButtonClick() {
        this.layoutService.showRightMenu();
    }

    onSearchClick() {
        this.layoutService.toggleSearchBar();
    }

    onRightMenuClick() {
        this.layoutService.showRightMenu();
    }

    get logo() {
        const logo =
            this.layoutService.config().menuTheme === 'white' ||
            this.layoutService.config().menuTheme === 'orange'
                ? 'dark'
                : 'white';
        return logo;
    }

    Logout() {
        console.log("logging out...");
        this.userService.logOut(this.id).subscribe({
            next: (response) => {
                console.log("Operation Successful" + response)
            },

            error: (error: HttpErrorResponse) => {
                console.error('Error occurred:', {
                    status: error.status,
                    statusText: error.statusText,
                    message: error.message,
                    url: error.url
                });
            },
        });
    }

    editProfile() {
        console.log("edit starts.");
        window.location.href = `${environment.editUrl}/${this.token}`;
    }

    onChooseLanguage() {
        this.dropdownVisible = !this.dropdownVisible;
    }

    onLanguageChange(event: any) {
        const selectedLanguageCode = event.value;
        this.dropdownVisible = false;
        this.translateService.use(selectedLanguageCode.value);
        console.log('Language changed to:', selectedLanguageCode);
    }


}
